import { RouterError } from './router-error'

export default RouterError
